import React, { useContext, useEffect, useRef, useState } from "react";
import { getIgameMediaStreamingProps, getStreamingBalanceLimit } from "./streamingUtils";
import { UserContext } from "../betslip/UserConf";
import MessageInfo from "../../common/MessageInfo";
import { getConfiguration } from "../utils";
import HLSJSPlayer from "./players/HLSJSPlayer";
import THEOlivePlayer from "./players/THEOlivePlayer";
import { getLabel } from "../../InitData";
import { systemCode, xs_isMobile, xs_languageCode } from "../..";

const streamTypes = {
    'hls' : {id: 2, name:"HLS"},
    'ull' : {id: 4, name:"ULL"}

};

function IgameMediaStreamPlayer(props) {
    const igameMediaProps = getIgameMediaStreamingProps()?.[0];
    const streamLinkData = props.streamLinkData;
    const liveStreamData = props.liveStreamData;
    const iframeRef = useRef();

    
    return (
        <>
        {streamLinkData?.streamType == 'PLAYER'?
            <iframe ref={iframeRef} src={streamLinkData.streamLink} title="igamemedia-live-stream" scrolling="yes" className={"igamemedia-iframe-live-streaming"}></iframe>
        :
        streamLinkData?.streamType == 'STREAM'?
            <>
            {liveStreamData?.StreamType == streamTypes['hls']['id']?
                <HLSJSPlayer streamSource={liveStreamData?.StreamLink} />
            :liveStreamData?.StreamType == streamTypes['ull']['id']?
                <THEOlivePlayer scriptSrc={igameMediaProps?.igmtheopu} channelId={liveStreamData?.StreamLink} token={liveStreamData?.StreamToken} />
            :
            <div>Unknown stream type: { liveStreamData?.StreamType}</div>
            }
            </>
        :
            <div>Unknown stream type: { streamLinkData?.streamType}</div>
        }
        </>
           
    )
}

export default function IgameMediaStreaming(props) {
    const conf = getConfiguration();
    const igameMediaProps = getIgameMediaStreamingProps()?.[0];
    const userContext = useContext(UserContext);
    const user = userContext.getUser();
    const balanceLimit =  getStreamingBalanceLimit();
    const isBalanceLimited = balanceLimit >0 && balanceLimit > user.balance;
    const streamingId = props.streamId;
    const [streamingData, setStreamingData] = useState({ 
        status : 'not_loaded',
        eventStreams: null,
        streamLinkData: null,
        liveStreamData: null,
        update(updt){
            setStreamingData(prev => {
                return {...prev, ...updt};
            });
        },
        reset() {
            this.update({status:'not_loaded'}); 
        },
        setReady() {
            this.update({status:'ready'});
        },
        setLoaded() {
            this.update({status:'loaded'});
        },
        setEventStreams(eventStreams){
            this.update({eventStreams});
        },
        setStreamLinkData(streamLinkData) {
            this.update({streamLinkData});
        },
        setLiveStreamData(liveStreamData) {
            this.update({liveStreamData});
        }

    });
    
    const [isErr,setIsErr] = useState(false);
    const [errMsg,setErrMsg] = useState(null);

    useEffect(() => {
            streamingData.reset();
    }, [props.matchId]);

    /*
    useEffect(() => {
        loadEventStreams();
        return () => {
            setIsErr(false);
            setErrMsg(null);
        }

    }, [streamingId]);

    useEffect(() => {
        if(streamingData?.eventStreams) {
            streamingData.setReady();
            loadStreamLinkData();
        }
       
        return () => {
            setIsErr(false);
            setErrMsg(null);
        }

    }, [streamingData?.eventStreams]);
    */

    useEffect(() => {
        loadStreamLinkData();
        return () => {
            setIsErr(false);
            setErrMsg(null);
        }

    }, [streamingId]);

    useEffect(() => {
        if(streamingData?.streamLinkData?.streamType == 'PLAYER') {
            streamingData.setLoaded();
        }else if(streamingData?.streamLinkData?.streamType == 'STREAM') {
            loadLiveStreamData();
        }
       
        return () => {
            setIsErr(false);
            setErrMsg(null);
        }

    }, [streamingData?.streamLinkData]);

    useEffect(() => {
        if(streamingData?.liveStreamData) {
            streamingData.setLoaded();
        }
       
        return () => {
            setIsErr(false);
            setErrMsg(null);
        }

    }, [streamingData?.liveStreamData]);

    /*const loadEventStreams = function() {
        try {
            const eventStreamsUrl = igameMediaProps?.igmesu?.replace('{{EVENTID}}',streamingId).replace('{{CUSTOMERID}}',igameMediaProps?.igmci);
            const request = new XMLHttpRequest();
            request.open('GET',eventStreamsUrl, true);
            request.timeout = 60000;
            request.onreadystatechange = function() {
                            try {
                                if (request.readyState == 4) {
                                    if(request.status == 200) {
                                        if(request.responseText){
                                            const eventStreamsData = JSON.parse(request.responseText);
                                            if(eventStreamsData?.operationCode == 200){
                                                if(eventStreamsData.eventStreams){
                                                    streamingData.setEventStreams(eventStreamsData.eventStreams);
                                                }else{
                                                    setErrMsg(getLabel('live_page.stream_widget.stream_not_available'))
                                                    throw new Error(eventStreamsUrl+": No eventStreams found ");
                                                }
                                            }else{
                                                setErrMsg(eventStreamsData?.message);
                                                throw new Error(eventStreamsUrl+": Status code "+eventStreamsData?.operationCode);
                                            }
                                        }else{
                                            throw new Error(eventStreamsUrl+": Empty response");
                                        }
                                    }else{
                                        throw new Error(eventStreamsUrl+": Response code "+request.status);
                                    }
                                }
                            }catch(err){
                                console.log(err);
                                setIsErr(true);
                            }
            }
            request.send();
        }catch(err) {
            console.log(err);
            setIsErr(true);
        }
    }

    const loadStreamLinkData = function() {
        try {
            const eventStreamULL = streamingData?.eventStreams?.find(s => {return s.streamType == streamTypes['ull']['name']});
            const eventStreamHLS = streamingData?.eventStreams?.find(s => {return s.streamType == streamTypes['hls']['name']});
            const eventStream = eventStreamULL || eventStreamHLS;
            const streamLinkUrl = igameMediaProps?.igmslu?.replace('{{EVENTID}}',streamingId)
                                                          .replace('{{CUSTOMERID}}',igameMediaProps?.igmci)
                                                          .replace('{{USERID}}',user?.nickname)
                                                          .replace('{{USERIP}}',getPublicIp())
                                                          .replace('{{STREAMNAME}}',eventStream?.uniqueStreamName)
                                                          .replace('{{REDIRECTURL}}',window.location.origin)
            const request = new XMLHttpRequest();
            request.open('POST',streamLinkUrl, true);
            request.timeout = 60000;
            request.onreadystatechange = function() {
                try {
                    if (request.readyState == 4) {
                        if(request.status == 200) {
                            if(request.responseText){
                                const streamLinkData = JSON.parse(request.responseText);
                                if(streamLinkData?.operationCode == 200){
                                    if(streamLinkData){
                                        streamingData.setStreamLinkData(streamLinkData);
                                    }else{
                                        setErrMsg(getLabel('live_page.stream_widget.stream_not_available'))
                                        throw new Error(streamLinkUrl+": No stream link found ");
                                    }
                                }else{
                                    setErrMsg(streamLinkData?.message);
                                    throw new Error(streamLinkUrl+": Status code "+streamLinkData?.operationCode);
                                }
                            }else{
                                throw new Error(streamLinkUrl+": Empty response");
                            }
                        }else{
                            throw new Error(streamLinkUrl+": Response code "+request.status);
                        }
                    }
                }catch(err){
                    console.log(err);
                    setIsErr(true);
                }
            }
            request.send();
        }catch(err) {
            console.log(err);
            setIsErr(true);
        }
    }
    */

    const loadStreamLinkData = function() {
        try {
            const queryParams = [];
            queryParams.push("systemCode=" + systemCode);
            queryParams.push("hash=");
            queryParams.push("lingua=" + xs_languageCode.toUpperCase());
            queryParams.push("eventId=" + streamingId);
            queryParams.push("userId=" + user?.nickname);
            queryParams.push("redirectUrl=" + window.location.origin);
            const getStreamingDataUrl = conf['api']['getLiveStreamingIgameMediaData'];  
            const request = new XMLHttpRequest();
            request.open('POST',getStreamingDataUrl + "?" + queryParams.join("&"), true);
            request.timeout = 60000;
            request.onreadystatechange = function() {
                try {
                    if (request.readyState == 4) {
                        if(request.status == 200) {
                            if(request.responseText){
                                const streamLinkData = JSON.parse(request.responseText);
                                if(streamLinkData?.operationCode == 200){
                                    if(streamLinkData){
                                        streamingData.setStreamLinkData(streamLinkData);
                                    }else{
                                        setErrMsg(getLabel('live_page.stream_widget.stream_not_available'))
                                        throw new Error(getStreamingDataUrl+": No stream link found ");
                                    }
                                }else{
                                    setErrMsg(streamLinkData?.message);
                                    throw new Error(getStreamingDataUrl+": Status code "+streamLinkData?.operationCode);
                                }
                            }else{
                                throw new Error(getStreamingDataUrl+": Empty response");
                            }
                        }else{
                            throw new Error(getStreamingDataUrl+": Response code "+request.status);
                        }
                    }
                }catch(err){
                    console.log(err);
                    setIsErr(true);
                }
            }
            request.send();
        }catch(err) {
            console.log(err);
            setIsErr(true);
        }
    }

    const loadLiveStreamData = function() {
        const liveStreamUrl = igameMediaProps?.igmlsu?.replace('{{ENCODEDSTREAMLINK}}',streamingData.streamLinkData?.streamLink)                              
        const request = new XMLHttpRequest();
        request.open('POST',liveStreamUrl, true);
        request.timeout = 60000;
        request.onreadystatechange = function() {
            try {
                if (request.readyState == 4) {
                    if(request.status == 200) {
                        if(request.responseText){
                            const liveStreamData = JSON.parse(request.responseText);
                            const operationCode = liveStreamData?.operationCode || liveStreamData?.OperationCode;
                            if(operationCode == 200){
                                if(liveStreamData){
                                    streamingData.setLiveStreamData(liveStreamData);
                                }else{
                                    setErrMsg(getLabel('live_page.stream_widget.stream_not_available'))
                                    throw new Error(liveStreamUrl+": No live stream found ");
                                }
                            }else{
                                setErrMsg(liveStreamData?.message);
                                throw new Error(liveStreamUrl+": Status code "+operationCode);
                            }
                        }else{
                            throw new Error(liveStreamUrl+": Empty response");
                        }
                    }else{
                        throw new Error(liveStreamUrl+": Response code "+request.status);
                    }
                }
            }catch(err){
                console.log(err);
                setIsErr(true);
            }
        }
        request.send();
    }


    try {
        return (
            <>{isErr?
                (!xs_isMobile?
                    <div className="bg-nero bianco">
                        {errMsg || 'Error loading stream, something went wrong'}
                    </div>
                    :
                    errMsg || 'Error loading stream, something went wrong'
                )
                
                :
                <div className={`igamemedia-streaming-container  ${props.isMobile?'xs_embeddedContent':''}`}>
                {user.logged?
                    (!isBalanceLimited ?
                        streamingData.status === 'not_loaded' ?
                            <div className="bg-nero bianco" >{getLabel('live_page.stream_widget.loading')}</div>
                            :
                            streamingData.status === 'ready'?
                                <div className="bg-nero bianco">{getLabel('live_page.stream_widget.preparing')}</div>
                                :
                                streamingData.status === 'loaded' ?
                                    <IgameMediaStreamPlayer streamLinkData={streamingData.streamLinkData} liveStreamData={streamingData.liveStreamData} />
                                    :
                                    <MessageInfo message={getLabel('live_page.stream_widget.stream_not_available')} />
                            :
                            <MessageInfo message={getLabel('live_page.stream_widget.insufficient_balance')} />
                    )
                    :
                    <MessageInfo message={getLabel('live_page.stream_widget.must_login')} />
                }
            </div>
            }
            </>
           
        );
    }catch(err) {
        return <MessageInfo message={getLabel('live_page.stream_widget.error')} />
    }
}